// import 'swiper/css';
import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FC, useState, useEffect } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import EditorLink from 'lowcode/components/EditorLink';
import styled from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';
import { useMembersStore } from '@/components/MembersDay/MembersProvider';
import { IPageStatus } from '@/components/MembersDay/type';
interface IProps {
    type?: string;
    cls?: string;
}

const localLink: any = {
    us: 'https://bit.ly/3TjvfHb',
    ca: 'https://bit.ly/43jkmJU',
    kr: 'https://bit.ly/3wqiTFp',
    au: 'https://bit.ly/3uB61et',
    za: 'https://bit.ly/43e6IHO',
    eu: 'https://bit.ly/3SD67L2',
    uk: 'https://bit.ly/49lV4Nx',
    de: 'https://bit.ly/3SMwjCR',
    fr: 'https://bit.ly/49I50Rk',
    it: 'https://bit.ly/4bFLjv5',
    es: 'https://bit.ly/3SD67L2',
    jp: 'https://lin.ee/Hq6cIaE',
};
const Banner: FC<IProps> = ({ cls }) => {
    const { locale } = getLocal();
    const { t } = useLang('membersday.teaser.EcoBenefits');
    const [gap, setGap] = useState(0);
    const [enter, setEnter] = useState(0);
    const { pageStatus } = useMembersStore();

    const arr = [
        {
            img: [
                'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711006398205/Ultimate%20Benefitsjpg.jpg',
                'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711006374533/Ultimate%20Benefitsjpg.jpg',
            ],
            title: t('itemTitleA'),
            sub: t('itemSubTitleA'),
            desc: t('itemDescA'),
        },
        {
            img: [
                'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711336352405/Reliable%20Services-pcjpg.jpg',
                'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711336370498/Reliable%20Services-mojpg.jpg',
            ],
            title: t('itemTitleB'),
            sub: t('itemSubTitleB'),
            desc: t('itemDescB'),
        },
        {
            img: [
                'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1710667619178/Flexible%20Energy%20Futurejpg.jpg',
                'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1710667649962/Flexible%20Energy%20Futurejpg.jpg',
            ],
            title: t('itemTitleC'),
            sub: t('itemSubTitleC'),
            desc: t('itemDescC'),
            link: localLink[locale] || localLink.us,
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window?.innerWidth <= 1024 ? 16 : 0);
        }
    }, []);

    useEffect(() => {
        // AniContainer.create({
        //     triggerElement: `.${cls}-EcoBenefits`,
        //     triggerHook: 1,
        //     offset: 300,
        //     duration: '300%',
        //     onEnter: () => setEnter(true),
        //     onLeave: () => setEnter(false),
        // });

        if (typeof window !== 'undefined' && window?.innerWidth > 1024) {
            setTimeout(
                () => {
                    const sceneA = AniContainer.create({
                        asyncFromTo: [
                            [`.${cls}-EcoBenefits .swiper-list-1 .text-box`, { opacity: 1, y: 0 }, { opacity: 0, y: -100 }, 0.3],

                            [`.${cls}-EcoBenefits .swiper-list-1 .video-box`, { opacity: 1, y: 0 }, { opacity: 0, y: -0 }, 0.0001],
                            [`.${cls}-EcoBenefits .swiper-list-2 .video-box`, { opacity: 0, y: 0 }, { opacity: 1, y: -0 }, 0.0001],
                            [`.${cls}-EcoBenefits .swiper-list-2 .text-box`, { opacity: 0, y: 100 }, { opacity: 1, y: 0 }, 0.3],

                            [`.${cls}-EcoBenefits .swiper-list-2 .text-box`, { opacity: 1, y: 0 }, { opacity: 0, y: -100 }, 0.3],

                            [`.${cls}-EcoBenefits .swiper-list-2 .video-box`, { opacity: 1, y: 0 }, { opacity: 0, y: -0 }, 0.0001],
                            [`.${cls}-EcoBenefits .swiper-list-3 .video-box`, { opacity: 0, y: 0 }, { opacity: 1, y: -0 }, 0.0001],
                            [`.${cls}-EcoBenefits .swiper-list-3 .text-box`, { opacity: 0, y: 100 }, { opacity: 1, y: 0 }, 0.3],
                        ],
                        asyncTimeLine: [0, 0.6, 0.6, 0.6, 1.5, 2, 2, 2],
                        triggerElement: `.${cls}-EcoBenefits`,
                        triggerHook: 1,
                        offset: '100%',
                        duration: '200%',
                    });
                    AniContainer.scrollHandle(); //执行一次初始化
                    return () => AniContainer.removeScene(sceneA);
                },
                cls === 'activity' ? 6000 : 10,
            );
        }
    }, []);

    return (
        <div className={`${cls}-EcoBenefits ${styled.Banner} EcoBenefits`} id="teaser-EcoBenefits">
            <div className="box-outer">
                <div className="sticky">
                    <div className={`info-box ${enter ? 'enter' : ''}`}>
                        <p className="title">{t('title')}</p>
                        <p className="desc">{t('subTitle')}</p>
                    </div>
                    <div className="swiper-box">
                        <Swiper
                            className="swiper-lists"
                            modules={[Scrollbar]}
                            spaceBetween={gap}
                            // centeredSlides={true}
                            slidesPerView={'auto'}
                            initialSlide={0}
                            scrollbar={{
                                hide: false,
                                draggable: true,
                                dragSize: 32,
                                snapOnRelease: true,
                            }}
                        >
                            {arr?.map((list: any, k: number) => (
                                <SwiperSlide className={`swiper-list swiper-list-${k + 1}`} key={list.id}>
                                    <div className="video-box">
                                        <EditorImg pc={list.img[0]} h5={list.img[1]} alt={list.title} aria-label={list.title} />
                                    </div>
                                    <div className="text-box">
                                        <div className="text-inner">
                                            <p className="list-title">{list.title}</p>
                                            <p className="list-sub">{list.sub}</p>
                                            <p className="list-desc">{list.desc}</p>
                                            {list?.link && (
                                                <EditorLink href={list?.link} className="list-link">
                                                    {t('itemJoinUs')}
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M9 18L15 12L9 6"
                                                            stroke="#FFBD3C"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </EditorLink>
                                            )}
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;
